
import { PlusCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface ClassesHeaderProps {
  onAddClass: () => void;
}

export const ClassesHeader = ({ onAddClass }: ClassesHeaderProps) => {
  const { t } = useTranslation("classes");

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between mb-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{t('title')}</h1>
        <p className="text-muted-foreground">
          {t('description')}
        </p>
      </div>
      <div className="flex items-center gap-2 mt-4 md:mt-0">
        <Button 
          size="sm" 
          variant="primary"
          className="h-9"
          onClick={onAddClass}
        >
          <PlusCircle className="mr-2 h-4 w-4" />
          {t('addClass')}
        </Button>
      </div>
    </div>
  );
}
